/**
 * Session activity tracking
 * Supports inactivity-based session timeout.
 */
(function () {
  if (
    typeof AttributionUtils === 'undefined' ||
    typeof AttributionUtils.touchSessionActivity !== 'function'
  ) {
    return;
  }

  var EVENTS = ['click', 'scroll', 'keydown', 'touchstart'];
  var DEBOUNCE_MS = 5000;
  var timer = null;

  function onInteraction() {
    clearTimeout(timer);
    timer = setTimeout(function () {
      AttributionUtils.touchSessionActivity();
    }, DEBOUNCE_MS);
  }

  EVENTS.forEach(function (evt) {
    document.addEventListener(evt, onInteraction, { passive: true });
  });
})();